// This file is used to override the dev config in production builds. we don't want to include in our production bundle our dev secrets.

import { Config } from '.';

const emptyConfig: Config = null;
export default emptyConfig;
